<template>
	<div>
		<a class="hover-link" style="float:left;color:white;font-size: 14px;margin-right:20px; " @click="showModalTemp()">Add Additional Expenses</a>
		<modal  :scrollable="true" name="additional-expense-form" @before-open="beforeOpen" height="auto" :minHeight="800" width="80%">
			
				<div class="" id="expenseModal" role="dialog">
					<div class="">
						<!-- Modal content-->
						<additional-expense-form :building-id="buildingId"></additional-expense-form>			  			 					
					</div>
                </div>
		</modal>
	</div>
</template>
<script>
export default {
  props: ["buildingId"],
  data: function () {
    return {};
  },

  mounted() {
    //alert(this.buildingId);
  },

  methods: {
    beforeOpen(event) {},
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {},
    showModalTemp: function () {
      this.$modal.show("additional-expense-form");
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      this.$modal.show("additional-expense-form");
    },
    hide() {
      alert("close");
      this.$modal.hide("additional-expense-form");
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    total: function () {
      return this.expenseFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
  },
}; // Our Javascript logic
</script>